import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Calendar } from 'primereact/calendar'

const CLASS = 'insights-portal-editor-input'

const TextEditor = props => {
  const className = `${CLASS}${props.className ? ` ${props.className}` : ''}`

  const value = useMemo(
    () => (null === props.value || undefined === props.value || '' === props.value ? undefined : new Date(props.value)),
    [props.value]
  )

  const minDate = null == props.minDate || '' === props.minDate ? undefined : new Date(props.minDate)
  const maxDate = null == props.maxDate || '' === props.maxDate ? undefined : new Date(props.maxDate)
  const onValueChange = event => {
    const current = new Date()
    const date = new Date(event.value)
    date.setHours(current.getHours())
    date.setMinutes(current.getMinutes())
    date.setSeconds(current.getSeconds())
    if (props.onChange) props.onChange({ value: date.toISOString() })
  }

  return (
    <Calendar
      className={className}
      panelClassName="insights-portal PRAYTMTheme"
      placeholder={props.placeholder}
      readOnlyInput
      minDate={minDate}
      maxDate={maxDate}
      dateFormat="mm/dd/yy"
      value={value}
      inputStyle={{ border: 0, height: '1em', paddingLeft: 0 }}
      onChange={onValueChange}
    />
  )
}

TextEditor.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func
}

export default TextEditor
